import i18n from '@/plugins/i18n.js'

const baseClass = 'publishing px-1 d-flex white--text rounded-sm'
const posibleStatus = {
  UPLOADING: {
    css: `${baseClass} uploading`,
    text: i18n.t('shooting.status.uploading')
  },
  AI_PROCESSING: {
    css: `${baseClass} aiProcessing`,
    text: i18n.t('shooting.status.aiProcessing')
  },
  QUALITY_CONTROL: {
    css: `${baseClass} qualityControl`,
    text: i18n.t('shooting.status.qualityControl')
  },
  PUBLISHING: {
    css: `${baseClass} publishing`,
    text: i18n.t('shooting.status.publishing')
  },
  FINISHED: {
    css: `${baseClass} finished`,
    text: i18n.t('shooting.status.finished')
  }
}

export function getCssClass(content) {
  const status = posibleStatus[content]
  return status ? status.css : 'font-weight-bold'
}

export function getStatusText(content) {
  const status = posibleStatus[content]
  return status ? status.text : content
}
